import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Descriptions, Button, Collapse, Tag } from "antd";
import { Redirect } from "react-router-dom";
const { Panel } = Collapse;

function App(props) {
  const [response, setResponse] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const deleteAction = () => {
    Axios.delete(baseUrl + "order/" + props.match.params.id)
      .then((response) => {
        setDeleted(true);
      })
      .catch(function (error) {});
  };
  useEffect(() => {
    Axios.get(baseUrl + "order/" + props.match.params.id)
      .then((response) => {
        setResponse(response.data);
      })
      .catch(function (error) {});
  }, []);

  if (deleted) {
    return <Redirect to="/orders/list" />;
  }
  if (!response) {
    return <div>Loading</div>;
  }
  return (
    <div style={{ padding: "100px 0" }}>
      <Descriptions title="Ürün Bilgileri" bordered layout="vertical">
        <Descriptions.Item label="Isim Soyisim">
          <p style={{ fontSize: "20pt" }}>
            {response.name} {response.surname}
          </p>
        </Descriptions.Item>
        <Descriptions.Item style={{ fontSize: "30px" }} label="Adres">
          <p style={{ fontSize: "30px" }}>
            {response.adress}
            {response.zipCode} {response.il}/{response.country}
          </p>
        </Descriptions.Item>
        <Descriptions.Item label="Telefon Numarası" span={1}>
          {response.phoneNumber}
        </Descriptions.Item>
        <Descriptions.Item label="E-Posta" span={1}>
          {response.email}
        </Descriptions.Item>
        <Descriptions.Item label="Sepet Toplamı" span={1}>
          {response.totalPrice} TL
        </Descriptions.Item>
        <Descriptions.Item label="Sipariş Durumu" span={1}>
          {response.status}
        </Descriptions.Item>
        <Descriptions.Item label="Satın Alınan Ürünler" span={3}>
          <Collapse bordered={false} defaultActiveKey={[0]}>
            {response.basketList.map((comp, id) => (
              <Panel header={`${comp.name}`} key={id}>
                <Descriptions bordered layout="horizontal">
                  <Descriptions.Item label="Ürün ">
                    <img src={comp.image} style={{ width: "50px" }}></img>
                  </Descriptions.Item>
                  <Descriptions.Item label="Ürün Adı">
                    {comp.name}
                  </Descriptions.Item>
                  <Descriptions.Item label="İndirim Oranı">
                    {comp.discount}
                  </Descriptions.Item>
                  <Descriptions.Item label="Adet">
                    <Tag color="magenta">{comp.count}</Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Fiyat" span={3}>
                    {comp.price}
                  </Descriptions.Item>
                </Descriptions>
              </Panel>
            ))}
          </Collapse>
        </Descriptions.Item>
      </Descriptions>
      {/* <div onClick={() => deleteAction()}>Delete</div> */}
    </div>
  );
}

export default App;
